module.exports = __webpack_public_path__ + "img/general1.46ecb326.jpg";